import { useMsalAuthentication, useMsal } from '@azure/msal-react';
import { InteractionType, InteractionStatus, AccountInfo  } from '@azure/msal-browser';
import { loginRequest, tokenRequest } from '../config/authConfig';
import { useAppContext } from '../hooks/context/AppContext';
import { useEffect } from 'react';
import useLocalStorage from "../hooks/useLocalStorage";


interface SSOAuthenticatorProps {
    children: React.ReactNode;
}

const SSOAuthenticator: React.FC<SSOAuthenticatorProps> = ({ children }) => {
    const [authData, setAuthData] = useLocalStorage("auth_data", null);
    const { login , error } = useMsalAuthentication(InteractionType.Silent, loginRequest);
    const { accounts, inProgress, instance } = useMsal();
    const { updateAuthData } = useAppContext();


    // let fetchUserProfile = async () => {
    //     let res = await getProfile()
    //     setLoading(false)
    //     if (res && res.data) {
    //       setUserInfo(JSON.stringify(res.data));
    //       updateUserData(res.data);
    //     } else {
    //       setisValidUser(false)
    //     }
    //   }
    

    // Function to update auth data and handle token refresh
    const updateAuthContext = async (account: AccountInfo) => {
       // console.log("authjh= sssooo-->",  account)
        try {
            // Get fresh token silently
            const tokenResponse = await instance.acquireTokenSilent({
                ...tokenRequest,
                account: account
            });
            // updateAuthData({
            //     homeAccountId: account.homeAccountId,
            //     environment: account.environment,
            //     tenantId: account.tenantId,
            //     username: account.username,
            //     localAccountId: account.localAccountId,
            //     name: account.name,
            //     authorityType: account.authorityType,
            //     tenantProfiles: account.tenantProfiles,
            //     idToken: tokenResponse.idToken,
            //     accessToken: tokenResponse.accessToken,
            //     // @ts-ignore
            //     expiresOn: tokenResponse.expiresOn?.getTime(),
            //     scopes: tokenResponse.scopes
            // });
            // setAuthData(JSON.stringify(
            //     {
            //         homeAccountId: account.homeAccountId,
            //         environment: account.environment,
            //         tenantId: account.tenantId,
            //         username: account.username,
            //         localAccountId: account.localAccountId,
            //         name: account.name,
            //         authorityType: account.authorityType,
            //         tenantProfiles: account.tenantProfiles,
            //         idToken: tokenResponse.idToken,
            //         accessToken: tokenResponse.accessToken,
            //         // @ts-ignore
            //         expiresOn: tokenResponse.expiresOn?.getTime(),
            //         scopes: tokenResponse.scopes
            //     }
            // ));


            return tokenResponse;
        } catch (silentError) {
            console.error('Silent token acquisition failed:', silentError);
            throw silentError;
        }
    };


    useEffect(() => {
        if (!accounts.length || inProgress !== InteractionStatus.None) return;

        const account = accounts[0];
        let refreshTimeout: NodeJS.Timeout;

        const setupTokenRefresh = async () => {
            try {
                const tokenResponse = await updateAuthContext(account);

                if (tokenResponse?.expiresOn) {
                    // Refresh token 1 minute before expiration
                    const expiresIn = tokenResponse.expiresOn.getTime() - Date.now() - 60000;
                    if (expiresIn > 0) {
                        refreshTimeout = setTimeout(() => {
                            setupTokenRefresh();
                        }, expiresIn);
                    }
                }
            } catch (error) {
                console.error('Token refresh setup failed:', error);
            }
        };

        // Initial setup
        setupTokenRefresh();

        // Event listener for token expiration
        const callbackId = instance.addEventCallback((event) => {
            if (event.eventType === 'msal:acquireTokenFailure') {
                //console.log('Token acquisition failed, attempting refresh...');
                setupTokenRefresh().catch(e => {
                    console.error('Token refresh failed:', e);
                });
            }
        });

        return () => {
            if (refreshTimeout) clearTimeout(refreshTimeout);
            if (callbackId) instance.removeEventCallback(callbackId);
        };
    }, [accounts, inProgress, instance]);

    // Handle initial authentication and errors
    useEffect(() => {
        if (error) {
            //('Silent login failed, attempting redirect...');
            login(InteractionType.Redirect, loginRequest).catch(e => {
                console.error('Login redirect failed:', e);
            });
        }
    }, [error, login]);

    // Update auth data when account changes
    useEffect(() => {
        if (accounts.length > 0 && inProgress === InteractionStatus.None) {
            const account = accounts[0];
            updateAuthContext(account).catch(e => {
                console.error('Initial auth context update failed:', e);
            });
        }
    }, [accounts, inProgress]);

    if (accounts.length > 0 && inProgress === InteractionStatus.None) {
        return <>{children}</>;
    }

    return null;
};

export default SSOAuthenticator;